// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"8132c79fb801ed8d0f0a","655":"53b97f7f8372e5532486"}[chunkId] + ".js";
};